import { useSelector } from "react-redux";
import { EntitlementType } from "../types/EntitlementTypes";
import {
  selectCurrentAccountEntitlements,
  selectHasEntitlement,
  selectHasAllEntitlements,
} from "../store/app-config/AppConfigSelectors";

export const useEntitlements = (): EntitlementType[] => {
  return useSelector(selectCurrentAccountEntitlements) as EntitlementType[];
};

export const useHasEntitlement = (entitlement: EntitlementType): boolean => {
  return useSelector(selectHasEntitlement(entitlement));
};

export const useHasAllEntitlements = (
  entitlements: EntitlementType[],
): boolean => {
  return useSelector(selectHasAllEntitlements(entitlements));
};
